import React, { useEffect, useState } from 'react';
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  CardActions,
  Grid,
  Button,
  Box,
  Stack,
  Skeleton,
} from '@mui/material';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { getProductById, getAllProducts } from '../../../Redux/ProductRedux.js';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import StarRatings from 'react-star-ratings';

const cardStyles = {
  card: {
    boxShadow: '0px 2px 4px 2px rgba(0, 0, 0, 0.1)',
    padding: '8px',
    marginBottom: '16px',
    pointer: 'cursor',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    '&:hover': {
      boxShadow: '0 6px 15px rgba(0, 0, 0, 0.3)',
    },
  },
  media: {
    height: '250px',
    objectFit: 'cover',
  },
  content: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    textAlign: 'center',
  },
  actions: {
    padding: 0,
    margin: 0,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
};

function NewArrivalsCards({ sectionName }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { allProducts } = useSelector((state) => state.productRedux);
  const [loading,setLoading] = useState(true);
 const BASE_URL = process.env.REACT_APP_API_URL;
  const handleCardClick = (product) => {
    const productId = product._id;
    dispatch(getProductById(productId));
    navigate(`/productDetails/${productId}`, { state: { product } });
  };

  useEffect(() => {
    dispatch(getAllProducts()).catch((error)=>{
      console.error("error",error)
    }).finally(()=>{
      setLoading(false)
    })
  }, [dispatch]);

  return (
    <>
      {loading ? (
        <div className='row'>
          <div className='col-3'>
            <Stack spacing={1}>
              <Skeleton variant='rounded' height={200} />
              <Skeleton variant='text' sx={{ fontSize: '.7rem' }} />
              <Skeleton variant='text' sx={{ fontSize: '.7rem' }} />
            </Stack>
          </div>
          <div className='col-3'>
            <Stack spacing={1}>
              <Skeleton variant='rounded' height={200} />
              <Skeleton variant='text' sx={{ fontSize: '.7rem' }} />
              <Skeleton variant='text' sx={{ fontSize: '.7rem' }} />
            </Stack>
          </div>
          <div className='col-3'>
            <Stack spacing={1}>
              <Skeleton variant='rounded' height={200} />
              <Skeleton variant='text' sx={{ fontSize: '.7rem' }} />
              <Skeleton variant='text' sx={{ fontSize: '.7rem' }} />
            </Stack>
          </div>
          <div className='col-3'>
            <Stack spacing={1}>
              <Skeleton variant='rounded' height={200} />
              <Skeleton variant='text' sx={{ fontSize: '.7rem' }} />
              <Skeleton variant='text' sx={{ fontSize: '.7rem' }} />
            </Stack>
          </div>
        </div>
      ) : (
        <Grid container spacing={2}>
          {allProducts
            .filter((product) => product.isFeatured)
            .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
            .filter((product, index) =>
              sectionName === 'home' ? index < 6 : true
            )
            .map((product) => (
              <Grid item xs={12} sm={4} md={2} lg={2} key={product._id}>
                <Card sx={cardStyles.card}>
                  <CardMedia
                    component='img'
                    sx={cardStyles.media}
                   image={`${BASE_URL}/assets/images/products/${product.images[0]?.image}`}
                    alt={product.productName}
                    onClick={() => handleCardClick(product)}
                  />
                  <CardContent sx={cardStyles.content}>
                    <Typography
                      variant='h6'
                      component='div'
                      className='card-title'
                      onClick={() => handleCardClick(product)}
                    >
                      {product.productName}
                    </Typography>

                    <Box
                      className=''
                      display='flex'
                      flexDirection='column'
                      alignItems='center'
                      mt={1}
                    >
                      <StarRatings
                        rating={Number(product.rating) || 0}
                        starRatedColor='gold'
                        numberOfStars={5}
                        starDimension='16px'
                        starSpacing='2px'
                        name='rating'
                      />
                      <Box mt={0.5} display='flex' alignItems='center'>
                        <CurrencyRupeeIcon
                          fontSize='small'
                          sx={{
                            verticalAlign: 'middle',
                            color: 'text.primary',
                          }}
                        />
                        <Typography variant='h5' fontWeight={600} ml={0.5}>
                          {product.priceAndQuantity &&
                          product.priceAndQuantity.length > 0
                            ? Math.min(
                                ...product.priceAndQuantity.map(
                                  (item) => item.price
                                )
                              ).toFixed(2)
                            : 'N/A'}
                        </Typography>
                      </Box>
                    </Box>
                  </CardContent>

                  <CardActions sx={cardStyles.actions}>
                    <Grid container>
                      <Grid item xs={12}>
                        <Button
                          startIcon={<ShoppingBagIcon />}
                          fullWidth
                          onClick={() => handleCardClick(product)}
                          variant='contained'
                          sx={{
                            backgroundColor: 'var(--primary-color)',
                            color: '#fff',
                            '&:hover': {
                              backgroundColor: 'var(--primary-color)',
                            },
                          }}
                        >
                          Buy Now
                        </Button>
                      </Grid>
                    </Grid>
                  </CardActions>
                </Card>
              </Grid>
            ))}
        </Grid>
        //     <Grid container spacing={3}>
        //   {allProducts
        //     .filter((product) => product.isFeatured)
        //     .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        //     .filter((product, index) => (sectionName === 'home' ? index < 4 : true))
        //     .map((product) => (
        //       <Grid item xs={12} sm={6} md={4} lg={3} key={product._id}>
        //         <Card
        //           sx={{
        //             borderRadius: 3,
        //             boxShadow: 3,
        //             transition: 'transform 0.3s ease-in-out',
        //             '&:hover': {
        //               transform: 'scale(1.02)',
        //             },
        //             display: 'flex',
        //             flexDirection: 'column',
        //             height: '100%',
        //           }}
        //         >
        //           <CardMedia
        //             component='img'
        //             image={product.images[0]?.image}
        //             alt={product.productName}
        //             height='200'
        //             sx={{
        //               objectFit: 'cover',
        //               borderTopLeftRadius: 12,
        //               borderTopRightRadius: 12,
        //               cursor: 'pointer',
        //             }}
        //             onClick={() => handleCardClick(product)}
        //           />

        //           <CardContent sx={{ textAlign: 'center', flexGrow: 1 }}>
        //             <Typography
        //               variant='subtitle1'
        //               fontWeight={600}
        //               gutterBottom
        //               sx={{ cursor: 'pointer' }}
        //               onClick={() => handleCardClick(product)}
        //             >
        //               {product.productName}
        //             </Typography>

        //             <Box display='flex' justifyContent='center' mt={1}>
        //               <StarRatings
        //                 rating={Number(product.rating) || 0}
        //                 starRatedColor='gold'
        //                 numberOfStars={5}
        //                 starDimension='16px'
        //                 starSpacing='2px'
        //                 name='rating'
        //               />
        //             </Box>

        //             <Box
        //               mt={1}
        //               display='flex'
        //               justifyContent='center'
        //               alignItems='center'
        //             >
        //               <CurrencyRupeeIcon fontSize='small' />
        //               <Typography variant='h6' fontWeight={700} ml={0.5}>
        //                 {product.priceAndQuantity?.length
        //                   ? Math.min(
        //                       ...product.priceAndQuantity.map((item) => item.price)
        //                     ).toFixed(2)
        //                   : 'N/A'}
        //               </Typography>
        //             </Box>
        //           </CardContent>

        //           <CardActions sx={{ p: 2 }}>
        //             <Button
        //               fullWidth
        //               variant='contained'
        //               startIcon={<ShoppingBagIcon />}
        //               onClick={() => handleCardClick(product)}
        //               sx={{
        //                 backgroundColor: 'var(--primary-color)',
        //                 color: '#fff',

        //                 borderRadius: 2,
        //                 '&:hover': {
        //                   backgroundColor: 'var(--primary-color)',
        //                 },
        //               }}
        //             >
        //               Buy Now
        //             </Button>
        //           </CardActions>
        //         </Card>
        //       </Grid>
        //     ))}
        // </Grid>
      )}
    </>
  );
}

export default NewArrivalsCards;
